<template>
  <nav class="navbar fixed-top p-0 bg-white">
    <div class="navbar-brand h-100 col mr-0 bg-dark clearfix">
      <a class="navbar-logo pr-2 float-left" href="/">
        <img src="../../assets/img/logo.svg" alt="itprint" />
      </a>
      <div
        class="navbar-sidbar-toggle rounded float-right cursor-pointer"
        tabindex="0"
        @click="toggleSidebar"
      >
        <i v-if="sidebarHidden" class="fa fa-angle-right"></i>
        <i v-else class="fa fa-angle-left"></i>
      </div>
    </div>
    <div class="navbar-acitons h-100 col d-flex justify-content-between">
      <div class="navbar-action d-flex align-items-center">
        <div class="navbar-action-separator"></div>
        <div class="h1 mb-0 ml-2">
          <slot name="navbar-action-page-name">{{pageHeader}}</slot>
        </div>
      </div>
      <div class="navbar-action d-flex align-items-center">
        <div
          class="navbar-action-account px-2 py-1"
          tabindex="0"
          :class="{'actions-active': isAccountOptionsVisible}"
          @click="toggleAccountOptions"
          @blur="closeAccountOptions"
        >
          <div class="d-flex justify-content-between align-items-center w-100">
            <span class="d-flex flex-column text-center align-items-center w-100">
              <span class="navbar-action-account__name w-100">{{userShortInfo}}</span>
              <span class="navbar-action-account__role w-100">{{roleName}}</span>
            </span>
            <i class="fa fa-angle-down d-flex"></i>
          </div>
          <ul
            class="navbar-action-account account-options list-unstyled"
            v-show="isAccountOptionsVisible"
          >
            <li class="account-options-item px-2" @click="accountSettings" @mousedown.prevent>
              <i class="fa fa-user"></i>
              <span class="ml-3">{{ $t('shared.account_settings') }}</span>
            </li>
            <li class="account-options-item px-2" @click="logout" @mousedown.prevent>
              <i class="fa fa-sign-out"></i>
              <span class="ml-3">{{ $t('shared.logout') }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapActions } from 'vuex'

import roles from '../../helpers/userRoles'

const getUserShortInfo = (firstName, lastName) => {
  return `${firstName} ${lastName}`
}

export default {
  name: 'Header',
  components: {
  },
  data: function () {
    return {
      roles,
      isAccountOptionsVisible: false,
      pageHeader: ''
    }
  },
  methods: {
    logout () {
      this.logoutUser()
        .then(() => {
          this.$router.push('/login')
        })
        .catch(() => this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        }))
    },
    accountSettings () {
      this.$router.push('/settings/personal-information')
    },
    toggleAccountOptions () {
      this.isAccountOptionsVisible = !this.isAccountOptionsVisible
    },
    closeAccountOptions () {
      this.isAccountOptionsVisible = false
    },
    ...mapActions({
      logoutUser: 'LOGOUT_USER',
      toggleSidebar: 'TOGGLE_SIDEBAR'
    })
  },
  computed: {
    sidebarHidden () {
      return this.$store.state.appSettings.sidebarHidden
    },
    userShortInfo () {
      return this.$store.state.userInfo
        ? getUserShortInfo(
          this.$store.state.userInfo.firstname,
          this.$store.state.userInfo.lastname
        )
        : ''
    },
    roleName () {
      return 'Администратор'
    }
  },
  created () {
    this.$eventBus.$on(
      'pageHeaderChange',
      newPageHeade => (this.pageHeader = newPageHeade)
    )
  }
}
</script>

<style lang="scss" scoped>
.navbar-action-account__role {
  font-size: 12px;
  text-transform: lowercase;
  color: #898c8f;
}
.navbar-action-account__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
